import React from 'react';
import PropTypes from 'prop-types';
import { getIn } from 'formik';
import { Input, FormFeedback } from 'reactstrap';
import { getFieldError, getValidity } from './validate';

const renderField = ({
  field,
  form,
  hasAttemptedSubmit,
  defaultValue,
  ...props
}) => {
  //  initialize field value if it has a default #1731
  if (!field.value && defaultValue && !getIn(form.touched, field.name)) {
    form.setFieldValue(field.name, defaultValue);
  }

  const touched = getIn(form.touched, field.name);
  const error = getFieldError(form, field.name);

  return (
    <div className="form__form-group-input-wrap--error-below">
      <Input
        {...props}
        {...field}
        {...getValidity(touched, error, hasAttemptedSubmit)}
        defaultValue={defaultValue}
      />
      {(touched || hasAttemptedSubmit) && error && (
        <FormFeedback className="validation form__form-group-error" tag="small">
          {error}
        </FormFeedback>
      )}
    </div>
  );
};

renderField.propTypes = {
  field: PropTypes.shape().isRequired,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
};

renderField.defaultProps = {
  placeholder: '',
  meta: null,
  type: 'text',
};

export default renderField;
